import PropTypes from 'prop-types'
import BootstrapLabel from 'react-bootstrap/FormLabel'

import { translate } from '@/utils/translations'

import Required from './Required'

const Label = ({
  field: {
    formParent,
    hasAsterisk,
    key,
    labelOverride
  }
}) => {
  const label = labelOverride
    ? translate(`${labelOverride}.${key}`)
    : translate(`${formParent}.labels.${key}`)

  return (
    <BootstrapLabel htmlFor={`${formParent}[${key}]`}>
      <Required hasAsterisk={hasAsterisk} />
      {label}
    </BootstrapLabel>
  )
}

export default Label

Label.propTypes = {
  field: PropTypes.shape({
    formParent: PropTypes.string.isRequired,
    hasAsterisk: PropTypes.bool.isRequired,
    key: PropTypes.string.isRequired,
    labelOverride: PropTypes.string
  })
}
